module.exports = __webpack_public_path__ + "static/media/fanciful.67088943.png";